import { Box } from "@mui/material";
import React from "react";
import LoaderImg from "../../assets/images/loader.gif"


const Loader = ({ open, message}) => {



    return (
        <>

            {open && <Box className="loaderMainContainer">

                <Box className="flex direction-column">
                    <img className="loaderImg" src={LoaderImg} alt="loader" />
                    <span variant="customh3" >{message}</span>

                </Box>

            </Box>}
        </>
    )
}

export default React.memo(Loader);